import React from 'react';

const baseFetch = {
  tafFetch: null,
  tafJce: null,
  lActId_: null,
  lPid_: null,
}

export const BaseFetch = React.createContext(
  baseFetch, // 默认值
);